import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import { getFuqiangxinApi } from '../api';
import { dbDataHandle } from '../store/function/common/index';
import i18n from '../lang/lang';
import { numberThousandsComma } from '@/utils/numberThousandsComma';

import { mapState, mapActions } from 'vuex';
var fuqiangxinList = ['富強鑫一期東側重建', '富強鑫西側整改', 'FCS2期', 'FCS3期', 'FCS4期', 'FCS5期', 'FCS6期'];
var fuqiangxinSetSite = ['東側南面', '西側南面', '東側慕品 A', '東側 11 - 12 棟南面 + 捷盟西', '捷盟東', '西側北面 + 慕品 M', '東側北面'];
var isInFuqiangxinList = function isInFuqiangxinList(obj) {
  return fuqiangxinList.includes(obj.displaySiteName);
};
var sortByFuqiangxinList = function sortByFuqiangxinList(sortKey) {
  return function (a, b) {
    return fuqiangxinList.indexOf(a[sortKey]) - fuqiangxinList.indexOf(b[sortKey]);
  };
};
export default {
  name: 'FuQiangXinDemo',
  data: function data() {
    return {
      fuqiangxinSetSite: fuqiangxinSetSite,
      factoryAccMonData: [],
      // 本月累計發電量
      factoryDayAvgPeakWattData: [],
      // 平均每日每kw發電量(峰瓩值)
      siteAcpSum: 0,
      // 本月累積發電量合計
      sitePriceSum: 0 // 本月累積售電金額合計
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['userDetail', 'factoryData', 'factoryInfo'])), {}, {
    fuqiangxinInfo: function fuqiangxinInfo() {
      return this.factoryInfo.filter(isInFuqiangxinList).sort(sortByFuqiangxinList('displaySiteName'));
    },
    fuqiangxinData: function fuqiangxinData() {
      return this.factoryData.filter(isInFuqiangxinList).sort(sortByFuqiangxinList('displaySiteName'));
    },
    alarmAmount: function alarmAmount() {
      // 告警數量 { "0": 5, "2": 2 } (key: displayAlertLevel)
      return this.factoryData.filter(isInFuqiangxinList).reduce(function (accumulator, curr) {
        if (!accumulator[curr.displayAlertLevel]) {
          accumulator[curr.displayAlertLevel] = 0;
        }
        accumulator[curr.displayAlertLevel] += 1;
        return accumulator;
      }, {});
    },
    siteCapacity: function siteCapacity() {
      // 為與舊雲端平台四捨五入後數字一致，先四捨五入再加總
      var total = this.fuqiangxinData.reduce(function (accumulator, curr) {
        return Math.round((accumulator + curr.capacityAll) * 100) / 100;
      }, 0);
      return total;
    },
    siteAcpToday: function siteAcpToday() {
      var _this = this;
      var total = this.fuqiangxinData.reduce(function (accumulator, curr) {
        return accumulator + _this.sumValue(curr.E_today);
      }, 0);
      return total.toFixed(2);
    },
    sitePowerPriceToday: function sitePowerPriceToday() {
      var _this2 = this;
      var total = this.fuqiangxinData.reduce(function (accumulator, curr, currIdx) {
        // 無 unitPrice(string): Number('-') -> NaN
        var unitPrice = Number(_this2.fuqiangxinInfo[currIdx].informations.unitPrice) || 0;
        return accumulator + _this2.sumValue(curr.E_today) * unitPrice;
      }, 0);
      return numberThousandsComma(total.toFixed());
    },
    sitePowerPriceMonth: function sitePowerPriceMonth() {
      return numberThousandsComma(this.sitePriceSum.toFixed());
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncSpecificLastDoc', 'asyncInfo', 'getAllAlarm'])), {}, {
    dbDataHandle: dbDataHandle,
    displayAlertLevelToText: function displayAlertLevelToText(displayAlertLevel) {
      if (displayAlertLevel === 0) return '系統正常營運';
      if (displayAlertLevel === 2) return '發電數據異常';
      if (displayAlertLevel === 3) return '部分通訊異常';
      if (displayAlertLevel === 5) return '資料缺漏回補';
      if (displayAlertLevel === 6) return '系統未連線';
      if (displayAlertLevel === 7) return '系統短暫斷線';
      if (displayAlertLevel === 9) return '發電效率不佳';
    },
    sumValue: function sumValue(v) {
      if (!(v !== null && v !== void 0 && v.length)) return 0;
      var value = this.dbDataHandle(v.reduce(function (a, b) {
        return a + b;
      }) * 1);
      if (value <= 0) return 0;
      return value;
    },
    handleInvSum: function handleInvSum(v) {
      if (v !== null && v !== void 0 && v.length) return this.dbDataHandle(v.reduce(function (a, b) {
        return a + b;
      }));
      return 0;
    },
    handleIRRArray: function handleIRRArray(irr) {
      var type = Object.prototype.toString.call(irr).slice(8, -1).toLowerCase();
      if (irr === undefined || irr === null) return;
      if (type && type === 'number') return irr;
      if (type && type === 'array') {
        if (irr.includes(null)) return null;
        return irr && irr !== null && irr !== void 0 && irr.length ? parseFloat(irr.reduce(function (a, b) {
          return a + b;
        }).toPrecision(12)) / (irr === null || irr === void 0 ? void 0 : irr.length) : 0;
      }
      if (type && type === 'object') return irr.avg ? irr.avg : 0;
    },
    getFuqiangxinData: function getFuqiangxinData() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$getFuqiangxinA, data, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getFuqiangxinApi();
              case 3:
                _yield$getFuqiangxinA = _context.sent;
                data = _yield$getFuqiangxinA.data;
                res = data.data;
                _this3.factoryAccMonData = res.accMon.sort(sortByFuqiangxinList('factoryName'));
                _this3.factoryDayAvgPeakWattData = res.dayAvgPeakWatt.sort(sortByFuqiangxinList('factoryName'));
                _this3.siteAcpSum = res.allSiteSum.siteAcpSum;
                _this3.sitePriceSum = res.allSiteSum.sitePriceSum;
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                console.log('getFuqiangxinData error', _context.t0);
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }))();
    }
  }),
  created: function created() {
    var _this4 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this4$factoryInfo;
      var hasFuqiangxinAllSitesPermission, displaySiteNameList, hasLoadedAllFuqiangxinData, queryFuqiangxinList;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 能進到這頁 代表 admin 以上 或是 富強鑫權限
              // 可看案場 ALL 或是 fuqiangxinList 所有案場
              // 可看富強鑫所有案場
              hasFuqiangxinAllSitesPermission = _this4.userDetail.factoriesList.includes('ALL') || fuqiangxinList.every(function (siteName) {
                return _this4.userDetail.factoriesList.includes(siteName);
              });
              if (!hasFuqiangxinAllSitesPermission) {
                _this4.$swal('權限不足，請洽系統管理員');
                _this4.$router.push({
                  path: "/".concat(i18n.locale, "/realtime")
                });
              }

              // 取得所有案場資訊、案場 alert level 數量
              if ((_this4$factoryInfo = _this4.factoryInfo) !== null && _this4$factoryInfo !== void 0 && _this4$factoryInfo.length) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return _this4.asyncInfo();
            case 5:
              _context2.next = 7;
              return _this4.getAllAlarm();
            case 7:
              // 取得富強鑫所有案場即時資訊
              displaySiteNameList = _this4.factoryData.map(function (obj) {
                return obj.displaySiteName;
              });
              hasLoadedAllFuqiangxinData = fuqiangxinList.every(function (siteName) {
                return displaySiteNameList.includes(siteName);
              });
              if (hasLoadedAllFuqiangxinData) {
                _context2.next = 13;
                break;
              }
              queryFuqiangxinList = _this4.factoryInfo.filter(isInFuqiangxinList); // 要共用 factoryData 才能得到即時資訊(websocket 是更新到 factoryData)
              _context2.next = 13;
              return _this4.asyncSpecificLastDoc(queryFuqiangxinList);
            case 13:
              _context2.next = 15;
              return _this4.getFuqiangxinData();
            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};